export const FLEX_DEMO_PATH = "/flex-demo";

/** Tablet and up (Mantine `sm` / 768px). Demo walkthrough is desktop/tablet only. */
export const FLEX_DEMO_MIN_VIEWPORT_MQ = "(min-width: 48em)";

/** False on SSR / unknown — never force the demo onto a phone before we can measure. */
export function isFlexDemoViewportSupported(): boolean {
  if (typeof window === "undefined") return false;
  return window.matchMedia(FLEX_DEMO_MIN_VIEWPORT_MQ).matches;
}

export const FLEX_DEMO_STEPS = [
  "explore",
  "preview",
  "express-interest",
  "auto-accept",
  "pay",
  "workspace",
  "finish",
] as const;

export type FlexDemoStep = (typeof FLEX_DEMO_STEPS)[number];

export const FLEX_DEMO_STEP_LABELS: Record<FlexDemoStep, string> = {
  explore: "Explore",
  preview: "Partner profile",
  "express-interest": "Express interest",
  "auto-accept": "Partner accepts",
  pay: "Unlock workspace",
  workspace: "Workspace & report",
  finish: "Finish",
};

export function flexDemoSessionStorageKey(userId: string): string {
  return `gt:flexDemo:${userId}`;
}
